<template>
  <div>
    <!--<BusLoader :spinner="spinner" :buses="buses" />
    <div v-if="!spinner && buses.length > 0">
      <Spinner v-if="this.$store.getters.isBusLoading" color="#fedd00" />
      <div v-else>
        <span class="">Buses disponibles</span>
        <BusTable
          :buses="buses"
          :loading="loading"
          :indexSelected="indexSelected"
          :pdfGenerate="pdfGenerate"
        />
      </div>
    </div>-->
    <Spinner v-if="this.$store.getters.isBusLoading" color="#fedd00" />
    <div v-else>
      <span class="">Buses disponibles</span>
      <BusTable
        :buses="buses"
        :loading="loading"
        :indexSelected="indexSelected"
        :pdfGenerate="pdfGenerate"
        :busesType="busesType"
      />
    </div>
  </div>
</template>

<script>
import BusTable from "./BusCardTable";
import BusLoader from "../BusUtils/BusLoader";
import { EventBus } from "../../../../EventBus";
import utilsColors from "../../../../utils/colors";
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import axios from "axios";
const baseUrl = process.env.VUE_APP_BASE_API;

export default {
  name: "BusCard",
  props: ["buses", "busesType"],
  mixins: [utilsColors],
  components: {
    BusLoader,
    BusTable,
    Spinner,
  },
  data() {
    return {
      loading: false,
      indexSelected: "",
      spinner: true,
    };
  },
  mounted() {
    EventBus.$on("BusesAreLoaded", this.onBusesLoaded.bind(this));
  },
  methods: {
    onBusesLoaded(areLoaded) {
      this.spinner = !areLoaded;
    },
    async pdfGenerate(id, name, index) {
      //// const type = this.$route.path == "/app/excursiones/excursiones" ? "excursion" : "pickup";
      let type = 'excursion'
      if ( this.$route.path == "/app/excursiones/pickups")
        type = "pickup"
      else if ( this.$route.path == "/app/excursiones/returns")
        type = "return"
      this.indexSelected = index;
      this.loading = true;
      await axios({
        url:
          baseUrl +
          `/pdfgenerator/bus/${type}/?day=${this.$store.getters.filterDate}&activity_group=${this.$store.getters.filterGroup}&bus=${id}`,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          this.$store.getters.filterDate +
            "_" +
            this.$store.getters.filterGroup +
            "_bus-" +
            name +
            "_type-" + type +
            ".pdf"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        this.loading = false;
        this.indexSelected = "";
      });
    },
  },
};
</script>